"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectActiveBetslipOddIdsByBetslipBet = exports.selectBetslipOddIdsWithoutEntities = exports.selectBetslipOddIdsWithEntities = exports.selectIsBetslipOddConflict = exports.selectConflictBetslipOddIds = exports.selectConflictedMatchesIds = exports.selectOddButtonView = exports.selectInitialBetslipBet = exports.selectCombinations = exports.selectBetslipBetTotals = exports.selectBetslipOddsWithOddRatioByBetslipBet = exports.makeSelectCombinationView = exports.selectBetslipBetWithStatus = exports.selectBetslipOddsByBetslipBetId = exports.selectBetslipOddsByChosenBetslipBet = exports.makeSelectBetslipOdds = exports.selectChosenBetslipBet = exports.selectBetslipBet = exports.selectBetslipOdd = exports.selectOddUpdateStatus = exports.selectChosenBetslipBetId = exports.selectBetslipBetIds = exports.selectBetslipBets = exports.selectBetslipOddIds = exports.selectBetslipOdds = exports.selectCombinationFromProps = exports.selectCombinationNumberFromProps = exports.selectBetslipBetIdFromProps = exports.selectBetslipOddIdFromProps = exports.selectBetslip = void 0;
var reselect_1 = require("reselect");
var immutable_1 = require("immutable");
var debug_1 = __importDefault(require("debug"));
var core_1 = __importStar(require("@gin-betting/core"));
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var _a = core_1.default.utils, getIdsFromBetslipOddId = _a.getIdsFromBetslipOddId, combine = _a.combine, getLetterByIndex = _a.getLetterByIndex, checkIsOddActiveByEntities = _a.checkIsOddActiveByEntities, _b = core_1.default.entities.selectors, selectMatches = _b.selectMatches, selectMarkets = _b.selectMarkets, selectOdds = _b.selectOdds, selectOddWithAvailability = _b.selectOddWithAvailability;
var debugPath = 'app:betslip:selectors:';
var selectBetslip = function (state) { return state.get(constants_1.NAME); };
exports.selectBetslip = selectBetslip;
var selectBetslipOddIdFromProps = function (_, props) {
    return props.betslipOddId;
};
exports.selectBetslipOddIdFromProps = selectBetslipOddIdFromProps;
var selectBetslipBetIdFromProps = function (_, props) {
    var debug = debug_1.default(debugPath + "selectBetslipBetIdFromProps");
    debug('args', { props: props });
    return props.betslipBetId;
};
exports.selectBetslipBetIdFromProps = selectBetslipBetIdFromProps;
var selectCombinationNumberFromProps = function (_, props) {
    return props.combinationNumber;
};
exports.selectCombinationNumberFromProps = selectCombinationNumberFromProps;
/** @deprecated */
var selectCombinationFromProps = function (_, props) {
    return props.combination;
};
exports.selectCombinationFromProps = selectCombinationFromProps;
exports.selectBetslipOdds = reselect_1.createSelector(exports.selectBetslip, function (_a) {
    var betslipOdds = _a.betslipOdds;
    return betslipOdds;
});
exports.selectBetslipOddIds = reselect_1.createSelector(exports.selectBetslipOdds, function (betslipOdds) { return betslipOdds.keySeq().toOrderedSet(); });
exports.selectBetslipBets = reselect_1.createSelector(exports.selectBetslip, function (_a) {
    var betslipBets = _a.betslipBets;
    return betslipBets;
});
exports.selectBetslipBetIds = reselect_1.createSelector(exports.selectBetslipBets, function (betslipBets) { return betslipBets.keySeq().toOrderedSet(); });
exports.selectChosenBetslipBetId = reselect_1.createSelector(exports.selectBetslip, function (_a) {
    var chosenBetslipBetId = _a.chosenBetslipBetId;
    return chosenBetslipBetId;
});
exports.selectOddUpdateStatus = reselect_1.createSelector(exports.selectBetslip, function (_a) {
    var oddUpdateStatus = _a.oddUpdateStatus;
    return oddUpdateStatus;
});
exports.selectBetslipOdd = reselect_1.createSelector(exports.selectBetslipOddIdFromProps, exports.selectBetslipOdds, function (betslipOddId, betslipOdds) { return betslipOdds.get(betslipOddId); });
exports.selectBetslipBet = reselect_1.createSelector(exports.selectBetslipBetIdFromProps, exports.selectBetslipBets, selectOdds, function (betslipBetId, betslipBets, odds) {
    var debug = debug_1.default(debugPath + "selectBetslipBet");
    debug('args without "entities.odds"', {
        betslipBetId: betslipBetId,
        betslipBets: betslipBets,
    });
    var betslipBet = betslipBets.get(betslipBetId);
    if (!betslipBet)
        return null;
    var betslipOddIds = betslipBet.betslipOddIds
        .filter(function (betslipOddId) {
        var oddId = getIdsFromBetslipOddId(betslipOddId).oddId;
        return odds.has(oddId);
    })
        .toOrderedSet();
    return __assign(__assign({}, betslipBet), { betslipOddIds: betslipOddIds });
});
exports.selectChosenBetslipBet = reselect_1.createSelector(exports.selectChosenBetslipBetId, exports.selectBetslipBets, function (chosenBetslipBetId, betslipBets) {
    var debug = debug_1.default(debugPath + "selectChosenBetslipBet");
    debug('args', { chosenBetslipBetId: chosenBetslipBetId, betslipBets: betslipBets });
    if (chosenBetslipBetId) {
        return betslipBets.get(chosenBetslipBetId);
    }
    return betslipBets.last();
});
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
function makeSelectBetslipOdds(currSelectBetslipBet) {
    return reselect_1.createSelector(currSelectBetslipBet, exports.selectBetslipOdds, function (betslipBet, betslipOdds) {
        return ((betslipBet === null || betslipBet === void 0 ? void 0 : betslipBet.betslipOddIds.toOrderedMap().map(function (betslipOddId) { return betslipOdds.get(betslipOddId); }).filter(function (betslipOdd) {
            return !!betslipOdd;
        })) || immutable_1.OrderedMap());
    });
}
exports.makeSelectBetslipOdds = makeSelectBetslipOdds;
exports.selectBetslipOddsByChosenBetslipBet = makeSelectBetslipOdds(exports.selectChosenBetslipBet);
exports.selectBetslipOddsByBetslipBetId = makeSelectBetslipOdds(exports.selectBetslipBet);
exports.selectBetslipBetWithStatus = reselect_1.createSelector(exports.selectBetslipBet, exports.selectBetslipOdds, function (betslipBet, betslipOdds) {
    var debug = debug_1.default(debugPath + "selectBetslipBetWithStatus");
    debug('args', { betslipBet: betslipBet, betslipOdds: betslipOdds });
    if (!betslipBet)
        return null;
    var betslipOddIds = betslipBet.betslipOddIds;
    var status = utils_1.getStatus({ betslipOddIds: betslipOddIds, betslipOdds: betslipOdds });
    return __assign(__assign({}, betslipBet), { status: status });
});
/** @deprecated */
var makeSelectCombinationView = function (stakeMode) {
    return reselect_1.createSelector(exports.selectCombinationFromProps, exports.selectBetslipBet, selectOdds, function (combination, betslipBet, odds) {
        var debug = debug_1.default(debugPath + "selectCachedCombinationView");
        debug('args without "entities.odds"', { combination: combination, betslipBet: betslipBet });
        if (!betslipBet)
            return null;
        var stake = betslipBet.stake, betslipOddIds = betslipBet.betslipOddIds, systemSize = betslipBet.systemSize;
        var betslipOddIdsList = betslipOddIds.toList();
        var oddValuePerCombination = 1;
        var letters = combination.map(function (betslipOddId) {
            var oddId = getIdsFromBetslipOddId(betslipOddId).oddId;
            var odd = odds.get(oddId);
            debug('oddId, odd from entities', { oddId: oddId, odd: odd });
            if (odd) {
                oddValuePerCombination *= odd.value;
            }
            return getLetterByIndex(betslipOddIdsList.indexOf(betslipOddId));
        });
        return {
            stake: stakeMode === core_1.GQL.StakeMode.total
                ? utils_1.getStakePerCombination(systemSize, betslipOddIds, +stake)
                : +stake,
            oddValuePerCombination: oddValuePerCombination,
            letters: letters,
        };
    });
};
exports.makeSelectCombinationView = makeSelectCombinationView;
exports.selectBetslipOddsWithOddRatioByBetslipBet = reselect_1.createSelector(exports.selectBetslipBet, exports.selectBetslipOdds, selectOdds, function (betslipBet, betslipOdds, odds) {
    var betslipOddsWithOddRatio = [];
    if (!betslipBet)
        return betslipOddsWithOddRatio;
    var betslipOddIds = betslipBet.betslipOddIds;
    betslipOddIds.forEach(function (betslipOddId) {
        var oddId = getIdsFromBetslipOddId(betslipOddId).oddId;
        var odd = odds.get(oddId);
        var betslipOdd = betslipOdds.get(betslipOddId);
        if (!betslipOdd || !odd)
            return;
        betslipOddsWithOddRatio.push(__assign(__assign({}, betslipOdd), { oddRatio: odd.value }));
    });
    return betslipOddsWithOddRatio;
});
exports.selectBetslipBetTotals = reselect_1.createSelector(exports.selectBetslipBet, exports.selectBetslipOddsWithOddRatioByBetslipBet, function (betslipBet, betslipOddsWithOddRatio) {
    var totals = { totalOdd: null, totalStake: 0, totalWin: 0 };
    if (!betslipBet)
        return totals;
    var mode = betslipBet.mode, stake = betslipBet.stake, systemSize = betslipBet.systemSize;
    switch (mode) {
        case core_1.GQL.BetType.SINGLE: {
            return utils_1.getSingleTotals(betslipOddsWithOddRatio);
        }
        case core_1.GQL.BetType.EXPRESS: {
            return utils_1.getExpressTotals(betslipOddsWithOddRatio, +stake);
        }
        case core_1.GQL.BetType.SYSTEM: {
            return utils_1.getSystemTotals(betslipOddsWithOddRatio, +stake, systemSize);
        }
        default: {
            return totals;
        }
    }
});
exports.selectCombinations = reselect_1.createSelector(exports.selectCombinationNumberFromProps, exports.selectBetslipBet, function (combinationNumber, betslipBet) {
    var debug = debug_1.default(debugPath + "selectCombinations");
    debug('args', { combinationNumber: combinationNumber, betslipBet: betslipBet });
    if (!betslipBet)
        return null;
    var betslipOddIds = betslipBet.betslipOddIds, systemSize = betslipBet.systemSize;
    var combinations = combine(betslipOddIds.toArray(), combinationNumber);
    var isChosen = systemSize.includes(combinationNumber);
    var betslipOddsSize = betslipOddIds.size;
    return { combinations: combinations, isChosen: isChosen, betslipOddsSize: betslipOddsSize };
});
exports.selectInitialBetslipBet = reselect_1.createSelector(exports.selectBetslipBets, exports.selectBetslipOdds, function (betslipBets, betslipOdds) {
    var debug = debug_1.default(debugPath + "selectInitialBetslipBet");
    debug('args', { betslipBets: betslipBets, betslipOdds: betslipOdds });
    return utils_1.getInitialBetslipBet({ betslipBets: betslipBets, betslipOdds: betslipOdds });
});
exports.selectOddButtonView = reselect_1.createSelector(selectOddWithAvailability, exports.selectChosenBetslipBet, exports.selectBetslipOddsByChosenBetslipBet, function (_a, chosenBetslipBet, chosenBetslipOdds) {
    var odd = _a.odd, isActive = _a.isActive;
    var emptyView = {
        isSelected: false,
        betslipBetId: '',
        isActive: false,
        betType: core_1.GQL.BetType.SINGLE,
        status: core_1.App.BetslipStatus.INITIAL,
    };
    if (!odd || !chosenBetslipBet) {
        return emptyView;
    }
    var betslipOddIds = chosenBetslipBet.betslipOddIds, betslipBetId = chosenBetslipBet.id, betType = chosenBetslipBet.mode;
    var betslipOddId = utils_1.getBetslipOddId({ oddId: odd.id, betslipBetId: betslipBetId });
    var isSelected = betslipOddIds.has(betslipOddId);
    return {
        isSelected: isSelected,
        betslipBetId: betslipBetId,
        isActive: isActive,
        status: utils_1.getStatus({
            betslipOddIds: betslipOddIds,
            betslipOdds: chosenBetslipOdds,
        }),
        // NOTE: Uncomment to enable multi betslip!
        // status:
        //     betType === GQL.BetType.SINGLE
        //         ? chosenBetslipOdds.get(betslipOddId)?.singleStatus || App.BetslipStatus.INITIAL
        //         : getStatus({
        //               betslipOddIds,
        //               betslipOdds: chosenBetslipOdds,
        //           }),
        betType: betType,
    };
});
exports.selectConflictedMatchesIds = reselect_1.createSelector(exports.selectBetslipBet, selectMatches, function (betslipBet, matches) {
    if (!betslipBet || betslipBet.mode === core_1.GQL.BetType.SINGLE)
        return [];
    var matchesInBetslip = betslipBet.betslipOddIds
        .map(function (betslipOddId) {
        var matchId = getIdsFromBetslipOddId(betslipOddId).matchId;
        return matches.get(matchId);
    })
        .filter(function (m) { return !!m; });
    return matchesInBetslip
        .groupBy(function (_a) {
        var tournament = _a.tournament;
        return tournament;
    })
        .filter(function (group) {
        return group.count() > 1;
    })
        .reduce(function (acc, group) {
        var result = group.some(function (_a) {
            var type = _a.type;
            return type === core_1.GQL.SportEventType.OUTRIGHT;
        })
            ? acc.concat(group.map(function (_a) {
                var id = _a.id;
                return id;
            }).toArray())
            : acc;
        return result;
    }, []);
});
exports.selectConflictBetslipOddIds = reselect_1.createSelector(exports.selectBetslipBet, exports.selectConflictedMatchesIds, function (betslipBet, conflictedMatchesIds) {
    var debug = debug_1.default(debugPath + "selectConflictBetslipOddIds");
    debug('args', { betslipBet: betslipBet });
    if (!betslipBet || betslipBet.mode === core_1.GQL.BetType.SINGLE)
        return [];
    var betslipOddIds = betslipBet.betslipOddIds;
    var conflictsMap = {};
    var entityIds = betslipOddIds.map(function (betslipOddId) {
        var matchId = getIdsFromBetslipOddId(betslipOddId).matchId;
        if (matchId in conflictsMap ||
            conflictedMatchesIds.includes(matchId)) {
            conflictsMap[matchId] = true;
        }
        else {
            conflictsMap[matchId] = false;
        }
        return { entityId: matchId, betslipOddId: betslipOddId };
    });
    var conflictBetslipOddIds = entityIds.reduce(function (acc, _a) {
        var entityId = _a.entityId, betslipOddId = _a.betslipOddId;
        if (conflictsMap[entityId]) {
            acc.push(betslipOddId);
        }
        return acc;
    }, []);
    return conflictBetslipOddIds;
});
exports.selectIsBetslipOddConflict = reselect_1.createSelector(exports.selectBetslipOddIdFromProps, exports.selectConflictBetslipOddIds, function (betslipOddId, conflictBetslipOddIds) {
    return conflictBetslipOddIds.includes(betslipOddId);
});
exports.selectBetslipOddIdsWithEntities = reselect_1.createSelector(exports.selectBetslipOddIds, selectMatches, selectMarkets, selectOdds, function (betslipOddIds, matches, markets, odds) {
    var debug = debug_1.default(debugPath + "selectOddButtonView");
    debug('args without "entities.matches", "entities.markets", "entities.odds"', { betslipOddIds: betslipOddIds });
    return betslipOddIds.filter(function (betslipOddId) {
        var _a = getIdsFromBetslipOddId(betslipOddId), oddId = _a.oddId, marketId = _a.marketId, matchId = _a.matchId;
        var hasMatch = matches.has(matchId);
        var hasMarket = markets.has(marketId);
        var hasOdd = odds.has(oddId);
        debug('checker', {
            hasMatch: hasMatch,
            hasMarket: hasMarket,
            hasOdd: hasOdd,
        });
        return hasMatch && hasMarket && hasOdd;
    });
});
exports.selectBetslipOddIdsWithoutEntities = reselect_1.createSelector(exports.selectBetslipOddIds, exports.selectBetslipOddIdsWithEntities, function (betslipOddIds, betslipOddIdsWithEntities) {
    return betslipOddIds.filterNot(function (betslipOddId) {
        return betslipOddIdsWithEntities.has(betslipOddId);
    });
});
exports.selectActiveBetslipOddIdsByBetslipBet = reselect_1.createSelector(exports.selectBetslipBet, selectMatches, selectMarkets, selectOdds, function (betslipBet, matches, markets, odds) {
    return (betslipBet === null || betslipBet === void 0 ? void 0 : betslipBet.betslipOddIds.filter(function (betslipOddId) {
        var _a = getIdsFromBetslipOddId(betslipOddId), oddId = _a.oddId, marketId = _a.marketId, matchId = _a.matchId;
        return checkIsOddActiveByEntities({
            oddId: oddId,
            marketId: marketId,
            sportEventId: matchId,
            matches: matches,
            markets: markets,
            odds: odds,
        });
    })) || immutable_1.OrderedSet();
});
//# sourceMappingURL=selectors.js.map